module.exports = __webpack_public_path__ + "static/media/google.a189e0be.svg";